import {
  DataTableDataSearchDto,
  ExtractedMetadataDto,
  TableModalRequestDto,
} from '@asset-metrix/portal-gateway-client-js';
import { Options } from '@asset-metrix/portal-ui';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

type FetchDocumentUploadModalValuesQueryKey = readonly [
  string,
  {
    contentId?: string;
    filter: DataTableDataSearchDto['selection'];
    context?: TableModalRequestDto['context'];
  },
];

export type ModalValues = { [p: string]: Options } | undefined;

export const fetchDocUploadModalValues: QueryFunction<
  ModalValues,
  FetchDocumentUploadModalValuesQueryKey
> = async ({ queryKey }) => {
  const [, { filter, contentId, context }] = queryKey;

  if (!contentId) {
    return;
  }

  const res = await portalGatewayClient.table.searchTableModalValues(
    contentId,
    { selection: filter, context }
  );

  if (res.data.status === 'success') {
    return res.data.data.modalValues;
  }
};

type FetchDocumentUploadAIModalValuesQueryKey = readonly [
  string,
  {
    contentId: string;
    file: File;
    userSelection: string;
  },
];

type DataFilterSelection = ExtractedMetadataDto['selection'] | undefined;

export const fetchDocUploadAIMetadataValues: QueryFunction<
  DataFilterSelection,
  FetchDocumentUploadAIModalValuesQueryKey
> = async ({ queryKey }) => {
  const [, { contentId, file, userSelection }] = queryKey;

  const res = await portalGatewayClient.table.extractDocumentMetadataWithAi(
    contentId,
    { file, userSelection }
  );

  if (!res.ok) {
    throw new HttpError(
      extractErrorMessage(res.error, 'Error extracting document metadata'),
      res
    );
  }

  return res.data.data.selection;
};
